export default {
    BASE_URL: '/pub/crm/mem/',
    api: [
        {
            name: 'search',
            desc: '搜索企业',
            method: 'GET',
            path: 'match'
        }
    ]
}



// WEBPACK FOOTER //
// ./src/api/pub/member.js